import { CustomerContractModel } from '../../../customers/shared/models/customer-contract-model';
import { Serializable } from '../../../core/models/serializable';
import { ThreadPostModel } from '../../../shared/models/comment-models/thread-post-model';
import { ThreadTopic } from '../../../shared/models/comment-models/thread-topic.enum';

export class PortfolioCustomerDetailsModel
  implements Serializable<PortfolioCustomerDetailsModel>
{
  fromObject(object: any): PortfolioCustomerDetailsModel {
    Object.assign(this, object);

    if (object.contract != null) {
      let t = new CustomerContractModel();
      t = t.fromObject(object.contract);
      this.contract = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public customerId: number;
  public customerName: string;
  public customerTaxCode: string;
  public customerCreateDate: Date;
  public contract: CustomerContractModel;
  public totalAnnouncements: number;
  public totalDbProducts: number;
  public totalSlider: number;
  public totalCvBoxProducts: number;
  public totalAmount: number;
  public totalInvoiceAmount: number;
  public paidAnnouncements: number;
  public freeAnnouncements: number;
  public totalPayments: number;
  public currentDebt: number;
  public oldDebt: number;
  public totalDebt: number;

  public lastComments: { [topic: number]: ThreadPostModel };

  constructor() {
    this.contract = new CustomerContractModel();
    this.lastComments = {};
  }
}
